import { useSettings } from 'settings';

export const useMainView = () => {
  const { modal = false, multipleFileUpload, enableExamples } = useSettings();

  return { modal, multipleFileUpload, enableExamples };
};
